// extracted by mini-css-extract-plugin
export default {"container":"experience_container__nikiA","title":"experience_title__RjgIh","mail":"experience_mail__LllCF","name":"experience_name__GV8GZ","textarea":"experience_textarea__uaB6H"};